var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "17px",
    viewBox: "0 0 18 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_report") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "site-actions",
    transform: "translate(-414.000000, -33.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_report_navy",
    transform: "translate(408.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon_report",
    strokeWidth: 1,
    fillRule: "evenodd",
    transform: "translate(7.000000, 9.000000)",
    stroke: "#004A99"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.27730364,6.42016079 L8.27730364,15.4201608",
    id: "Line"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-4",
    transform: "translate(8.234918, 8.636282) rotate(135.000000) translate(-8.234918, -8.636282) ",
    points: "5.58072933 6.01072797 6.03776798 10.7734894 10.8891064 11.261836"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-3",
    transform: "translate(8.000000, 6.728447) scale(1, -1) translate(-8.000000, -6.728447) ",
    points: "4.66662237 0.0184120494 0.0841465399 8.12048841e-15 0 13.423197 13.1101028 13.4568948 13.1676532 10.2546828 15.9563508 10.2517384 16 0.0824652342 11.1540372 0.075300561"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReport);
export default __webpack_public_path__ + "static/media/icon-report.537428165362ef7e7aa3aac05f6b37ec.svg";
export { ForwardRef as ReactComponent };